/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
import Header from "../header/Header";
import SideBar from "../sidebar/SideBar";
import "../../App.css";
import { useEffect, useState } from "react";
import { Button, Dropdown, Menu, Modal, Space, Spin, Table, Tag } from "antd";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { getUserQuoteById } from "../../lib/quotes";
import { generatePDF } from "../shared/pdf/generatePDF";
import { toast } from "react-toastify";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../../config/firebase";
import { FormatDate } from "../../lib/dateFormat";
import { PiDotsThreeVerticalBold } from "react-icons/pi";
import { useMyContext } from "../../context/MyContext";
import { getAlpha2Code } from "../../lib/helper/countryToAphlaCode";
import { generateShipmentLabel } from "../shared/pdf/shipmentLabel";
import Barcode from "react-barcode";
import AskForModel from "../shared/askForQuestion";
import DashboardLayout from "../layout";
import { api } from "../../config/api";
import dayjs from "dayjs";
import { useNavigate, useSearchParams, useLocation } from "react-router-dom";
import { pdf } from '@react-pdf/renderer';
import Loader from "../shared/loader/loader";


function MyShipment() {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const shipmentId = searchParams.get("ship");
  const obj = {
    active: true,
    content: "My Shipment",
  };
  const { user, notifications } = useMyContext();

  const location = useLocation();
  const [selectId, setSelectId] = useState(shipmentId ? shipmentId : "");
  const [isModalOpen, setIsModalOpen] = useState(shipmentId ? true : false);
  const [formData, setFormData] = useState(null);
  const [loadingPdf, setLoadingPdf] = useState(null);
  const [filteredData, setFilteredData] = useState("");
  const [trackingId, setTrackingId] = useState("");
  const [openDropdownIndex, setOpenDropdownIndex] = useState(null);
  const queryClient = useQueryClient();
  const [searchQuery, setSearchQuery] = useState("");
  const [showLoader, setShowLoader] = useState(true);
  const [trackingRedirectLoading, setTrackingRedirectLoading] = useState(false);


  const { data } = useQuery(
    ["userQuotes", user?.uid],
    async () => {
      const res = await getUserQuoteById(user?.uid);
      return res;
    },
    {
      refetchOnWindowFocus: false,
    }
  );

  useEffect(() => {
    if (data) {
      const searchParams = new URLSearchParams(location.search);
      const shipId = searchParams.get('ship');
      const quoteNumber = searchParams.get('quoteNumber');

      if (shipId) {
        const shipment = data.find(item => item.id === shipId);
        if (shipment) {
          setSelectId(shipId);
          setIsModalOpen(true);
        }
      } else if (quoteNumber) {
        const shipment = data.find(item => item.quoteNumber === quoteNumber);
        if (shipment) {
          setSelectId(shipment.id);
          setIsModalOpen(true);
        }
      } else {
        setIsModalOpen(false);
        setSelectId('');
      }

      FilterData();
    }
  }, [location.search, data, searchQuery]);



  const handleClickOutside = (event) => {
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const getStatusStyles = (status) => {
    switch (status?.toLowerCase()) {
      case "in progress":
        return {
          backgroundColor: '#fff9e0',
          color: '#FFC93F',
          border: '#FFC93F solid 1px'
        };
      case "delivered":
        return {
          backgroundColor: '#e8f7d2',
          color: '#7CE13E',
          border: '#7CE13E solid 1px'
        };
      case "canceled":
        return {
          backgroundColor: '#f7e5da',
          color: '#FF4A3F',
          border: '#FF4A3F solid 1px'
        };
      case "preparing collection":
        return {
          backgroundColor: '#fff9e0',
          color: '#FFC93F',
          border: '#FFC93F solid 1px'
        };
      case "in delivery":
        return {
          backgroundColor: '#e1effc',
          color: '#6A8EC8',
          border: '#6A8EC8 solid 1px'
        };
      case "transit air":
        return {
          backgroundColor: '#f7e5da',
          color: '#FF4A3F',
          border: '#FF4A3F solid 1px'
        };
      case "compliance":
        return {
          backgroundColor: '#f4ebfc',
          color: '#8D75C3',
          border: '#8D75C3 solid 1px'
        };
      case "warehouse shipment":
        return {
          backgroundColor: '#faf0de',
          color: '#A0673D',
          border: '#A0673D solid 1px'
        };
      case "storage":
        return {
          backgroundColor: '#e9d9fc',
          color: '#7460F1',
          border: '#7460F1 solid 1px'
        };
      case "final delivery":
        return {
          backgroundColor: '#e3f5d7',
          color: '#16A34A',
          border: '#16A34A solid 1px'
        };
      case "completed":
        return {
          backgroundColor: '#e3f5d7',
          color: '#16A34A',
          border: '#16A34A solid 1px'
        };
      default:
        return {
          backgroundColor: '#e1e9fa',
          color: '#1e40af',
          border: '#1e40af solid 1px'
        };
    }

  };
  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setSelectId('');
    const searchParams = new URLSearchParams(location.search);
    searchParams.delete('ship');
    searchParams.delete('quoteNumber');
    navigate(`${location.pathname}${searchParams.toString() ? `?${searchParams.toString()}` : ''}`, { replace: true });
  };

  const handleGeneratePdf = async (data) => {
    setLoadingPdf(data.id);
    try {
      if (data) {
        const blob = await generateShipmentLabel(data);
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = "shipmentLabel.pdf";
        link.click();
      } else {
        toast.error("Quote data not found");
      }
    } catch (error) {
      console.error("Error generating PDF:", error);
      toast.error("Error generating PDF: " + error.message);
    } finally {
      setLoadingPdf(null);
    }
  };

  const FilterData = () => {
    if (!data || !Array.isArray(data)) {
      setFilteredData([]);
      setShowLoader(false);
      return;
    }

    let filtered = data.filter(
      (item) => item.status !== "pending" && item.status !== "decline"
    );

    if (searchQuery.trim() !== "") {
      filtered = filtered.filter((directory) =>
        Object.values(directory).some(
          (value) =>
            typeof value === "string" &&
            value.toLowerCase().includes(searchQuery.toLowerCase())
        )
      );
    }

    filtered.sort(
      (a, b) =>
        dayjs(b.creationDate).valueOf() - dayjs(a.creationDate).valueOf()
    );

    setFilteredData(filtered);
    setShowLoader(false);

  };

  useEffect(() => {
    if (data) {
      FilterData();
    }
  }, [data, searchQuery]);

  const handleTrackClick = async () => {
    if (!trackingId) {
      toast.error("Please enter a tracking ID");
      return;
    }

    const match = filteredData.find((item) => item.trackingNumber === trackingId);
    if (!match) {
      toast.error("Tracking ID not found");
      return;
    }

    setTrackingRedirectLoading(true);
    try {
      const res = await api.get(`/tracking/trackshipment/${trackingId}`);
      const shipmentData = res?.data?.data;

      if (!shipmentData) {
        toast.error("Tracking ID not found");
        return;
      }

      navigate(`/trackshipment?trackingNumber=${encodeURIComponent(trackingId)}`, {
        state: {
          prefetchedShipment: shipmentData,
          trackingNumber: trackingId,
        },
      });
    } catch (error) {
      console.error("Tracking validation failed:", error);
      toast.error("Tracking ID not found");
    } finally {
      setTrackingRedirectLoading(false);
    }
  };

  const showModal = (id, quoteNumber) => {
    setSelectId(id);
    setIsModalOpen(true);
    const searchParams = new URLSearchParams(location.search);
    searchParams.set('ship', id);
    if (quoteNumber) {
      searchParams.set('quoteNumber', quoteNumber);
    } else {
      searchParams.delete('quoteNumber');
    }
    navigate(`${location.pathname}?${searchParams.toString()}`, { replace: true });
  };

  const handleCommentClick = async (id, quoteNumber) => {
    showModal(id, quoteNumber);

    try {
      await api.put(`/notifications/quotes/${user?.uid}`, {
        role: user?.role,
        quoteNumber: quoteNumber,
      });
      queryClient.invalidateQueries(["notifications"]);
    } catch (error) {
      console.error("Error updating notification:", error);
    }
  };



  const columns = [
    {
      title: "Order Number",
      dataIndex: "orderNumber",
      width: 130,
      align: "left",
    },
    {
      title: "Tracking Number",
      dataIndex: "trackingNumber",
      width: 140,
      align: "left",
    },
    {
      title: "Shipping Date",
      dataIndex: "creationDate",
      width: 120,
      align: "left",
      render: (creationDate) => FormatDate(creationDate),
    },
    {
      title: "Shipment Label",
      width: 140,
      align: "center",
      render: (_, record) => (
        <button
          onClick={() => handleGeneratePdf(record)}
          disabled={loadingPdf === record.id}
          className="px-2 flex gap-2 items-center justify-center text-xs rounded-md py-2 text-white bg-[#355FD8] w-full max-w-[120px] mx-auto disabled:bg-opacity-50"
        >
          {loadingPdf === record.id ? "Downloading..." : "Download Label"}
        </button>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      width: 150,
      align: "center",
      render: (status) => (
        <div
          className="capitalize rounded-md text-sm px-3 py-1 text-white text-center font-medium whitespace-nowrap"
          style={{
            ...getStatusStyles(status),
            display: "inline-block",
            minWidth: "90px",
          }}
        >
          {status.toUpperCase()}
        </div>
      ),
    },
    {
      title: "Ship To",
      width: 100,
      align: "center",
      render: (_, record) =>
        `${getAlpha2Code(record.loadCountry)} - ${getAlpha2Code(
          record.unloadCountry
        )}`,
    },
    {
      title: "ETA",
      dataIndex: "orderDetails",
      width: 100,
      align: "center",
      render: (orderDetails) => orderDetails?.eta || "N/A",
    },
    {
      title: "Actions",
      width: 80,
      align: "center",
      render: (_, record) => (
        <Dropdown
          overlay={
            <Menu>
              <Menu.Item key="askForQuestion">
                <Space
                  onClick={() =>
                    handleCommentClick(record.id, record.quoteNumber)
                  }
                >
                  Ask A Question
                </Space>
              </Menu.Item>
            </Menu>
          }
          visible={openDropdownIndex === record.id}
          trigger={["click"]}
          onVisibleChange={(visible) => {
            setOpenDropdownIndex(visible ? record.id : null);
          }}
        >
          <a
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              setOpenDropdownIndex(record.id);
            }}
          >
            <Space>
              <button className="border relative p-1 rounded-md border-blue-500">
                <PiDotsThreeVerticalBold size={20} />
                {notifications?.find(
                  (e) =>
                    e?.quoteNumber === record?.quoteNumber && e?.read === false
                ) ? (
                  <div className="w-2 h-2 absolute -top-[2px] right-0 bg-red-600 rounded-full"></div>
                ) : null}
              </button>
            </Space>
          </a>
        </Dropdown>
      ),
    },
  ];

  return (
    <>
      <Modal
        title={`Order No: ${data?.find((q) => q.id === selectId)?.orderNumber || data?.find((q) => q.id === selectId)?.quoteNumber}`}
        open={isModalOpen}
        centered
        footer={null}
        onOk={handleOk}
        onCancel={handleCancel}
        width={'70%'}
        styles={{ body: { padding: 0 } }}
      >
        <AskForModel id={selectId} />
      </Modal>
      <DashboardLayout>
        <div className="w-full h-full">
          <Header title="My Shipments" />
          {showLoader ? (
            <Loader />
          ) : (
            <div className="p-4 bg-cus-gray h-full">
              <div className="bg-white border rounded-md " >
                <div className="flex justify-between  items-center gap-5 w-full px-5 py-6">
                  <div className="flex items-center justify-between rounded-lg w-full lg:w-1/4 p-1 border-2 border-[#4D8EEB]">
                    <input
                      type="text"
                      placeholder="Enter Tracking ID"
                      onChange={(e) => {
                        const value = e.target.value.replace(/\D/g, '');
                        setTrackingId(value);
                      }}
                      value={trackingId}
                      className="w-full mr-2 p-2 text-sm focus:outline-none rounded"
                    />
                    <Button
                      type="primary"
                      className="py-2 px-4 text-sm whitespace-nowrap flex justify-center items-center"
                      onClick={handleTrackClick}
                      loading={trackingRedirectLoading}
                      disabled={trackingRedirectLoading}
                    >
                      Track
                    </Button>
                  </div>
                  <div className="w-full md:w-auto p-3 flex space-x-2 items-center rounded-md border-[#4D8EEB] border-2 ">
                    <input
                      placeholder="Search here"
                      className="outline-none w-full"
                      type="text"
                      name=""
                      id=""
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                    />
                  </div>
                </div>
                <div className="w-full px-5">
                  <Table
                    columns={columns}
                    dataSource={filteredData}
                    size="small"
                    className="table w-full border-0"
                    scroll={{ x: 960 }}
                    tableLayout="fixed"
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      </DashboardLayout>
    </>
  );
}

export default MyShipment;